import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import swal from 'sweetalert';
import _  from 'lodash';
import TableSection from '../../organisms/tableSection/tableSectionv3';
import { updateItems, updateItem, tableEdited, getSortedItems, bulk } from '../../../store/externalCalls/api/listTableApi';
import { storeStructure } from '../../../store/reducers';
import { composeURL, appendParamsToURL } from '../../../utils/urlTools';
import FooterButton from '../../molecules/formFooter/formFooter';
import PreventTransitions from '../../molecules/preventTransitions/preventTransitions';
import FormUploadSync from '../../molecules/formUploadSync/formUploadSync';
import Button, { ButtonTheme } from '../../atoms/button/button';
import { httpDelete, httpGet, httpGetFile,httpPost, httpPut } from '../../../store/externalCalls/httpCalls';
import Label from '../../atoms/label/label';
import Toaste from '../../atoms/toast/toaste';
import { getCookie } from '../../../store/sessionStore';
import { mapPagination } from '../../../store/externalCalls/api/maps';

const ListTableComponent = (props) => {
  const {
    classId,
    configFile,
    tableName,
    mode,
    onCreate,
    editURL,
    onSave,
    onDelete,
    onChange,
    onChangeAndRefresh,
    value,
    selValue,
    dataSelected,
    itemId,
    filterByParticularId,
    maxElementsSelectable,
    onAfterEdit,
    initialValuesRef,
    match
  } = props;

  const dispatch = useDispatch();  
  const params = useParams();
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const itemChanged = useSelector((state) => state.session.isBlocking);
  const [updatedValues, setUpdateValues] = useState();
  const [itemsSelected, setitemsSelected] = useState([]);
  const [searchParams, setSearchParams] = useState();
  const [websocketLogOpen, setWebsocketLogOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const serializedState = getCookie('state');
  const [valueTable,setValueTable] =useState(null);
  const [exports, setExports] = useState({});
  const [buttonError,setButtonError] =useState(null);
  const [buttonExport,setButtonExport] =useState(null);
  const [showImportPopup,setShowImportPopup] =useState(false);
  let timeout=null;

  const id = configFile.idAttribute !== undefined
    ? params[configFile.idAttribute] : undefined;

  useEffect(() => {
    if (!configFile?.fetchOnMount) return;
    if (!configFile?.getURL) return;
    if (configFile?.fetchOnMount) {
      if (valueTable && valueTable?.data !== undefined) return;
      if (!configFile?.getURL) return;
      const editId = configFile.idAttribute !== undefined
        ? params[configFile.idAttribute]
        : undefined;

      const url = composeURL(session, configFile.sessionParams || [], configFile.getURL, editId);
      httpGet(url, process.env.REACT_APP_API_ENDPOINT)
        .then((valuesRequest) => {
          let values;
          if (valuesRequest[configFile.attributeName]) {
            values = mapPagination(valuesRequest[configFile.attributeName]);
          } else {
            values = mapPagination(valuesRequest);
          }
          setValueTable(values);
        })
        .catch(() => { });
    }
  }, [configFile?.fetchOnMount, configFile?.getURL, params?.[configFile?.idAttribute], session]);
  useEffect(() => {
    setitemsSelected(dataSelected);
    if(value){
      let v=null;
      if(value.current_page){
       v=mapPagination(value);
      }else{
        v=value;
      }
      setValueTable(v);
    }
  }, [value]);
  const handlerChangePage = (url) => {
    httpGet(url, process.env.REACT_APP_API_ENDPOINT)
    .then((valuesRequest) => {
      let values;
      if(valuesRequest[configFile.attributeName]){
        values = mapPagination(valuesRequest[configFile.attributeName]);
      }else
        values = mapPagination(valuesRequest);
      
      setValueTable(values);
    }).catch(() => {
      // To catch abort errors, not remove!
    });
  };
  const handleFilter = (filters) => {
    let customSession={};
    if(filterByParticularId){
      customSession={...session,...filterByParticularId};
    }
    let editId="";
    let location=window.location.pathname;
    let locationArr = location.split("/");
    let lastId=locationArr[locationArr.length-1];
    if(isNumber(lastId)){
      editId="/"+locationArr[locationArr.length-1];
    }
    let url=null;
    if(filterByParticularId)
      url = composeURL(customSession, configFile.sessionParams, configFile.getURL, id);
    else
      url = composeURL(session, configFile.sessionParams, configFile.getURL, id);

    const searchURL = appendParamsToURL(url, filters);
    if(isNumber(lastId)){
      window.history.pushState({}, '', appendParamsToURL('', filters));
    }
    httpGet(searchURL, process.env.REACT_APP_API_ENDPOINT)
    .then((valuesRequest) => {
      let values="";
      if(valuesRequest[configFile.attributeName])
        values = mapPagination(valuesRequest[configFile.attributeName]);
      else
        values = mapPagination(valuesRequest);
      setValueTable(values);
    }).catch(() => {
      // To catch abort errors, not remove!
    });
  };

  const handlerSort = (sort) => {
    const url = composeURL(session, configFile.sessionParams, configFile.getURL, id);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const { attributeName, sortDown } = sort;
    const orderList = sortDown ? 'asc' : 'desc';
    const obj = {
      sort_by: attributeName,
      order: orderList,
    };

    if (queryString.length === 0) {
      const searchURL = appendParamsToURL(url, obj);
      setSearchParams(searchURL);
      getSortedItems(searchURL, dispatch);
      window.history.pushState({}, '', appendParamsToURL('', obj));
    } else if (!urlParams.has('order')) {
      const urlWithParams = appendParamsToURL('', obj) + queryString.replace('?', '&');
      window.history.pushState({}, '', urlWithParams);

      const searchURL = appendParamsToURL(url, obj) + queryString.replace('?', '&');
      setSearchParams(searchURL);
      getSortedItems(searchURL, dispatch);
    } else if (urlParams.has('order')) {
      const temp = [...urlParams.entries()];
      const temp2 = [['sort_by', attributeName], ['order', orderList]];

      temp.map((value) => {
        temp2.map((value2) => {
          if (value[0] === value2[0]) {
            urlParams.set(value[0], value2[1]);
          }
        });
      });

      window.history.pushState({}, '', `?${urlParams.toString()}`);
      setSearchParams(`${url}?${urlParams.toString()}`);
      getSortedItems(`${url}?${urlParams.toString()}`, dispatch);
    } else {
      window.history.pushState({}, '', appendParamsToURL('', obj));
      const searchURL = appendParamsToURL(url, obj);
      setSearchParams(searchURL);
      getSortedItems(searchURL, dispatch);
    }
  };
  const handlerErrors = (e) => {
    const messages = e.errors === undefined ? { general: 'Something was wrong' } : e.errors;
    if(e.button){
      setButtonError(e.button);
    }
    setErrors(messages);
    if(!e.button){
      setTimeout(() => {
        setErrors({});
      }, 5000);
    }
  };

  const handlerCreate = (item) => {
    setErrors({});
    const url = composeURL(session, configFile.sessionParams, configFile.createURL, id);
    httpPost(url, item).then((newItem)=>{
      let newValues=mapPagination(newItem);
      setValueTable(newValues);
    },(e)=>{
      handlerErrors(e);
    });
  };

  const handlerClickRow = (newitemsSelected) => {
    setitemsSelected(newitemsSelected);
    if(!configFile.bulkSelectable){
      onChange(newitemsSelected);
    }
  };

  const getData = () => {
    // console.log("get data from table");
    // console.log(configFile);
  };


  const delayedQuery = useCallback(_.debounce((dataSet) => {
    const url = (dataSet.newValue == "status") ?  composeURL(session, configFile.sessionParams, configFile.updateURL, dataSet.dataSetIndex) : composeURL(session, configFile.sessionParams, configFile.updateURL, id);
    updateItems(url, dataSet, dispatch, configFile.updateValuesAfterUpdate)
      .then(() => {

      }, (e) => {
        handlerErrors(e);
      });
  }, 300), [session, configFile, id]);

  const handlerUpdate = (dataSet) => {
      clearTimeout(timeout);
      timeout= setTimeout(()=>{
        const url = composeURL(session, configFile.sessionParams, configFile.updateURL, id);
        httpPut(url, dataSet).then((updatedValues)=>{
          let newDataSet=null;
          if(updatedValues[configFile.attributeName])
            newDataSet =mapPagination(updatedValues[configFile.attributeName]);
          else
            newDataSet =mapPagination(updatedValues);
          setValueTable(newDataSet);
          onChange(newDataSet);
        },(e)=>{
          handlerErrors(e);
        });
      },500);
     
  };

  const handlerUpdateOrderItems = (dataSet) => {
    setUpdateValues(dataSet);
    if (configFile.autoUpdate === true) {
      const url = composeURL(session, configFile.sessionParams, configFile.updateURL, id);
      updateItems(url, dataSet, dispatch)
        .then(() => {
          getData();
        }, (e) => {
          handlerErrors(e);
        });
    } else {
      tableEdited(dispatch);
    }
    onChange(dataSet);
  };

  const handlerSaveButton = () => {
    console.log("old save");
  };
  const closeImportPopup=()=>{
    setShowImportPopup(false);
  }
  const isNumber=(value)=> {
    return !isNaN(Number(value));
  }

  const handlerRemoveItem = (item) => {
    let editId="";
    let location=window.location.pathname;
    let locationArr = location.split("/");

    let lastId=locationArr[locationArr.length-1];
    if(isNumber(lastId)){
      editId=locationArr[locationArr.length-1];
    }else{
      editId=undefined;
    }
    swal({
      title: 'Are you sure?',
      text: configFile.deleteRecordText?configFile.deleteRecordText:'You are removing a item.',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const url = composeURL(session, configFile.sessionParams, configFile.removeURL, editId);
        httpDelete(url+"/"+item.id).then((res)=>{
          let values;
          if(res[configFile.attributeName]){
            values = mapPagination(res[configFile.attributeName]);
          }else{
            values = mapPagination(res);
          }
          setValueTable(values);
        },(error) => {
          handlerErrors(error);
        });
      }
    });
  };

  const handlerOnChangeItemPosition = (item) => {
    const url = composeURL(session, configFile.sessionParams, configFile.removeURL, item.id);
    updateItem(url, { ...item, toOrder: true }, dispatch).then(() => {
      window.location.reload();
    }, (e) => {
      handlerErrors(e);
    });
  };


  const handlerExportButton = () => {
    const url = composeURL(session, configFile.sessionParams, configFile.exportAction, id);
    httpGetFile(url, configFile.exportName);
  };

  const handlerUploadSync = () => {
    if (configFile.importMonitoringChanel) {
      setWebsocketLogOpen(true);
    } else {
      window.location.reload();
    }
  };


  const handlerBulkDelete = (itemsToRemove) => {
    console.log("old bulk delete");
  };

  const handleActionUrl=(actionUrl)=>{
    console.log("old action url");
  }
  const handleChangeAndRefresh=(e)=>{
    onChangeAndRefresh(e);
  }

  const handlerBulkAction =(action,itemsSelected,type)=>{
    var promise = new Promise( (resolve, reject) => {
      if(action=="bulkImport" || action=="bulkEdit"){
        //never passes here
      }else{
        swal({
          title: 'Are you sure?',
          text: 'You are about to '+action+' over '+itemsSelected.length+' items.',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        }).then((ok) => {
          if (ok) {
            if(action=="bulkExport"){
              setExports(["Preparing the file to be exported..."]);
              setButtonExport(null);
              const idsToSend = itemsSelected.map((itemToSend) => {
                return itemToSend.id;
              });
              const url = composeURL(session, configFile.sessionParams, configFile.getURL);
              setitemsSelected([]);
              
              bulk(url,{action:action,ids: idsToSend,type:type}, dispatch).then((urlExport) => {
                let b ={id:"button-bulkExported",title:"Export",actionUrl:urlExport,actionParams:idsToSend};
                setButtonExport(b);
                setExports(["here is the file exported"]);
                resolve(true);
              }, (e) => {
                handlerErrors(e);

              }); 
            }else{

              const idsToSend = itemsSelected.map((itemToSend) => {
                return itemToSend.id;
              });
              const url = composeURL(session, configFile.sessionParams, configFile.getURL);
              setitemsSelected([]);
              bulk(url,{action:action,ids: idsToSend}, dispatch).then((res) => {
                onChangeAndRefresh(res);
              }, (e) => {
                handlerErrors(e);

              });
              resolve(true);
            }
          }else{
            reject("error");
          }
        });
      }
    });
    return promise;
  }

  return (
    <div id={classId}>
       {Object.keys(errors).length > 0
      && (
        <Toaste type="error" mode="toast" data={errors} />
      )}
      { configFile.loadFromFile !== undefined
      && (
        <FormUploadSync
          endpoint={composeURL(session, configFile.sessionParams, configFile.loadFromFile, id)}
          helpText={configFile.loadFromFileHelp}
          fileExtensionType={configFile.fileExtensionType}
          onSuccess={handlerUploadSync}
        />
      )}
      { configFile.exportAction
      && (
      <div className="form-group row">
        <Label helpText={configFile.exportHelp}>{configFile.exportHelp}</Label>
        <div className="col-sm-8">
          <Button theme={ButtonTheme.INFO} onClick={handlerExportButton}>Download file</Button>
        </div>
      </div>
      )}
     {valueTable && valueTable.data !== undefined
      && (
      <TableSection
        configFile={configFile}
        mode={mode}
        tableName={tableName}
        editURL={editURL}
        // urlParams={configFile}
        valuesPaginated={valueTable}
        id={id}
        session={session}
        onChangePage={handlerChangePage}
        onSearch={handleFilter}
        onClickCreate={handlerCreate}
        onChangeItem={handlerUpdate}
        onChangeAndRefresh={handleChangeAndRefresh}
        onClickRemoveItem={handlerRemoveItem}
        onChangeItemPosition={handlerOnChangeItemPosition}
        onClickBulkDelete={handlerBulkDelete}
        onBulkAction={handlerBulkAction}
        onAfterEdit={onAfterEdit}
        initialValuesRef={initialValuesRef}
        onOrderItems={(dataValues, isDrag) => {
          if (isDrag) {
            handlerUpdate(dataValues);
          } else {
            handlerUpdateOrderItems(dataValues);
          }
        }}
        onSort={handlerSort}
        onClickRow={handlerClickRow}
        itemId={itemId}
        maxElementsSelectable={maxElementsSelectable}
        initDataSelected={configFile.isMultiSelectable === true || selValue!=null ? itemsSelected : itemsSelected}
      />
      )}
      {(!valueTable || valueTable == null) && 
      <div>{configFile.emptyMessage?configFile.emptyMessage:"No records on this table"}</div>}
      <PreventTransitions />
      {itemChanged === true && (configFile.autoUpdate == undefined || configFile.autoUpdate == false)
      && (
        <div className="footer-section">
          <FooterButton onClick={handlerSaveButton}>Save</FooterButton>
        </div>
      )}
       {showImportPopup && 
        <div>popup to be shown
        <button label="close" title="close" onClick={closeImportPopup}>Close popup</button>
        </div>
      }
    </div>
  );
};

ListTableComponent.propTypes = {
  /**
   * Confinguration file to create a table
   */
  configFile: PropTypes.shape({
    noArea: PropTypes.bool,
    title: PropTypes.string,
    // getURL: PropTypes.string,
    createURL: PropTypes.string,
    updateURL: PropTypes.string,
    removeURL: PropTypes.string,
    idAttribute: PropTypes.string,
    websocketEventChanel: PropTypes.string,
    sessionParams: PropTypes.arrayOf(PropTypes.string),
    sessionWebsocketParams: PropTypes.arrayOf(PropTypes.string),
    loadFromFile: PropTypes.string,
    loadFromFileHelp: PropTypes.string,
    exportAction: PropTypes.string,
    exportHelp: PropTypes.string,
    exportName: PropTypes.string,
    websocketItem: PropTypes.string,
    updateValuesAfterUpdate: PropTypes.arrayOf(PropTypes.string),
    autoUpdate: PropTypes.bool,
    importMonitoringChanel: PropTypes.string,
    importMonitoringTitle: PropTypes.string,
    importMonitoringSessionParams: PropTypes.arrayOf(PropTypes.string),
    // tableConfig: PropTypes.shape({
    //   fields: PropTypes.arrayOf(PropTypes.shape({})),
    // }),
  }).isRequired,
  onCreate: PropTypes.func,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  onAfterEdit: PropTypes.func,
};

ListTableComponent.defaultProps = {
  onCreate: () => {},
  onSave: () => {},
  onDelete: () => {},
  onChange: () => {},
  onAfterEdit: null,
};

export default ListTableComponent;
